module.exports = __webpack_public_path__ + "static/media/A9.ffd6239d.jpg";